import React from "react";

export default function DocumentVerification({ analysis, portrait, photoRequired }) {
  if (!analysis) return null;
  const labels = {
    MATCH: "Confere",
    MISMATCH: "Diferente do informado",
    UNREADABLE: "Não foi possível ler",
    READING_CONFLICT: "Leitura inconclusiva",
    PROFILE_MISSING: "Confira seus dados",
    NOT_REGISTERED: "Não informado",
  };
  return (
    <div className="signature-reading-issues" aria-label="Conferência do documento">
      <p>
        <strong>Foto no documento</strong>
        <span>
          {portrait?.result === "PRESENT"
            ? "Presente"
            : portrait?.result === "ABSENT"
              ? "Não encontrada"
              : "Não confirmada"}
        </span>
      </p>
      {[
        ["CPF", "cpf"],
        ["Nome", "name"],
        ["Data de nascimento", "birthDate"],
      ].map(([label, key]) => (
        <p key={key}>
          <strong>{label}</strong>
          <span>{labels[analysis.checks?.[key]] || "Pendente"}</span>
        </p>
      ))}
      {photoRequired && (
        <p role="alert">
          {portrait?.reason || "Não foi possível confirmar a foto no documento."}{" "}
          Repita a análise do mesmo arquivo ou substitua-o por um documento
          completo, com foto, CPF, nome e data de nascimento. Para frente e verso,
          use um único PDF de até 2 páginas.
        </p>
      )}
    </div>
  );
}
